import React from "react";
import { PageHeader } from "antd";
import JcpEnrollmentEntry from "../../components/enrollment/jcp/JcpEnrollmentEntry";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";

const JcpEnrollment = () => {
  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Enrollment - JCP (Tax Invoice With GST)"
          subTitle=""
          extra={[]}
        ></PageHeader>

        <JcpEnrollmentEntry />
      </div>
    </div>
  );
};

export default JcpEnrollment;
